// Guards against rare Bootstrap errors where internal teardown tries to call `.remove()`
// on a null element. This can happen if Angular removes an element before Bootstrap finishes.
(function () {
  const tryPatch = () => {
    try {
      const b = (typeof window !== 'undefined' ? window.bootstrap : undefined);
      if (!b) return false;

      const patchDestroyElement = (Ctor) => {
        try {
          const proto = Ctor && Ctor.prototype;
          if (!proto) return;
          const orig = proto._destroyElement;
          if (typeof orig !== 'function') return;
          if (orig.__mp_patched) return;

          const wrapped = function (...args) {
            const element = orig.length >= 1 ? args[0] : (this ? this._element : null);
            if (!element || typeof element.remove !== 'function') {
              try {
                if (this && typeof this.dispose === 'function') this.dispose();
              } catch {
                // ignore
              }
              return;
            }
            return orig.apply(this, args);
          };
          wrapped.__mp_patched = true;
          proto._destroyElement = wrapped;
        } catch {
          // ignore
        }
      };

      // Patch any Bootstrap components that implement _destroyElement (Alert in Bootstrap v5)
      for (const key of Object.keys(b)) {
        patchDestroyElement(b[key]);
      }

      // Alert also needs a guard on `close()` because it touches `this._element.classList`
      try {
        const alertProto = b.Alert && b.Alert.prototype;
        if (alertProto && typeof alertProto.close === 'function' && !alertProto.close.__mp_patched) {
          const origClose = alertProto.close;
          const wrappedClose = function (...args) {
            const element = this ? this._element : null;
            if (!element || !element.classList) {
              try {
                if (this && typeof this.dispose === 'function') this.dispose();
              } catch {
                // ignore
              }
              return;
            }
            return origClose.apply(this, args);
          };
          wrappedClose.__mp_patched = true;
          alertProto.close = wrappedClose;
        }
      } catch {
        // ignore
      }

      return true;
    } catch {
      return false;
    }
  };

  // Patch immediately and retry briefly in case load ordering differs.
  if (tryPatch()) return;

  let attempts = 0;
  const timer = setInterval(() => {
    attempts += 1;
    if (tryPatch() || attempts >= 40) {
      clearInterval(timer);
    }
  }, 50);
})();
